module.exports = __webpack_public_path__ + "assets/img/organization.abfa6fae.png";